import React, {Suspense} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Button, Result} from 'antd';
// import TagManager from 'react-gtm-module';
import LoggedInRoute from '../components/LoggedInRoute';
import LoggedOutRoute from '../components/LoggedOutRoute';
import Auth from '../components/Auth';
import Loader from '../components/Loader/Loader';

const CorporateLanding = React.lazy(() =>
    import(/* webpackChunkName: "CorporateLanding" */ 'views/CorporateLanding'),
);
const Login = React.lazy(() =>
    import(/* webpackChunkName: "Login" */ 'views/Login'),
);
const ChangePassword = React.lazy(() =>
    import(/* webpackChunkName: "ChangePassword" */ 'views/ChangePassword'),
);
const Unsubscribe = React.lazy(() =>
    import(/* webpackChunkName: "Unsubscribe" */ 'views/Unsubscribe'),
);
const RegistrationForm = React.lazy(() =>
    import(
        /* webpackChunkName: "RegistrationForm" */ 'views/LatestRegistrationForm'
    ),
);
const SsoLogin = React.lazy(() =>
    import(/* webpackChunkName: "SsoLogin" */ 'views/DirectLogin/SsoLogin'),
);
const LandingPage = React.lazy(() =>
    import(/* webpackChunkName: "LandingPage" */ 'views/LandingPage'),
);
const MacroPage = React.lazy(() =>
    import(/* webpackChunkName: "MacroPage" */ 'views/MacroPage'),
);
const ScreenerPage = React.lazy(() =>
    import(/* webpackChunkName: "ScreenerPage" */ 'views/ScreenerPage'),
);
const Watchlist = React.lazy(() =>
    import(/* webpackChunkName: "Watchlist" */ 'views/Watchlist'),
);
const AnalystsPage = React.lazy(() =>
    import(/* webpackChunkName: "AnalystsPage" */ 'views/AnalystsPage'),
);
const IndustryScreener = React.lazy(() =>
    import(/* webpackChunkName: "IndustryScreener" */ 'views/IndustryScreener'),
);
const CompanyPage = React.lazy(() =>
    import(/* webpackChunkName: "CompanyPage" */ 'views/CompanyPage'),
);
const IndustryPage = React.lazy(() =>
    import(/* webpackChunkName: "IndustryPage" */ 'views/IndustryPage'),
);
const CountryPage = React.lazy(() =>
    import(/* webpackChunkName: "CountryPage" */ 'views/CountryPage'),
);
const Disclaimer = React.lazy(() =>
    import(/* webpackChunkName: "Disclaimer" */ 'views/Disclaimer'),
);
const ETF = React.lazy(() => import(/* webpackChunkName: "ETF" */ 'views/ETF'));
const NetworkGraph = React.lazy(() =>
    import(
        /* webpackChunkName: "NetworkGraph" */ 'components/NetworkGraph/Network'
    ),
);
const CorporateAccess = React.lazy(() =>
    import(/* webpackChunkName: "CorporateAccess" */ 'views/CorporateAccess'),
);
const VerifyRegistrationPage = React.lazy(() =>
    import('views/VerifyRegistrationPage'),
);

const PreLoginPage = React.lazy(() => import('views/PreLogin'));

const GiveAwayTncPage = React.lazy(() => import('views/GiveAwayTnc'));

const RatesPage = React.lazy(() => import('views/RatesPage'));

const CurrencyPage = React.lazy(() => import('views/CurrencyPage'));

const DigitalAssetPage = React.lazy(() => import('views/DigitalAssetPage'));

const CreditStrategyPage = React.lazy(() => import('views/CreditStrategyPage'));

const TermsPage = React.lazy(() => import('views/Terms'));

const LearnPage = React.lazy(() => import('views/LearnPage'));
// const tagManagerArgs = {
//     gtmId: 'GTM-5N89Q6',
// };

// if (process.env.NODE_ENV === 'production') {
//     TagManager.initialize(tagManagerArgs);/
// }

const AppRouter = () => {
    return (
        <Router basename="/insightsdirect">
            <Suspense
                fallback={
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh',
                            width: '100%',
                        }}
                    >
                        <Loader />
                    </div>
                }
            >
                <Switch>
                    <Route exact path="/" component={Auth} />
                    <Route path="/telegramgiveaway" component={PreLoginPage} />
                    <Route path="/giveaway" component={GiveAwayTncPage} />
                    <Route path="/changePassword" component={ChangePassword} />
                    <Route path="/unsubscribe" component={Unsubscribe} />
                    <Route path="/terms" component={TermsPage} />
                    <LoggedOutRoute path="/login" component={Login} />
                    <LoggedOutRoute path="/home" component={Login} />
                    <LoggedOutRoute
                        exact
                        path="/register"
                        component={RegistrationForm}
                    />
                    <LoggedOutRoute
                        path="/register/verify"
                        component={VerifyRegistrationPage}
                    />
                    <LoggedOutRoute path="/sso/:data?" component={SsoLogin} />

                    <LoggedInRoute
                        path="/landingpage"
                        component={LandingPage}
                    />
                    <LoggedInRoute path="/macro" component={MacroPage} />
                    <LoggedInRoute
                        exact
                        path="/screener"
                        component={ScreenerPage}
                    />
                    <LoggedInRoute
                        path="/screener/industry"
                        component={IndustryScreener}
                    />
                    <LoggedInRoute
                        path="/digitalassets/:id?/:name?"
                        component={DigitalAssetPage}
                    />
                    <LoggedInRoute
                        path="/company/:id?/:name?"
                        component={CompanyPage}
                    />
                    <LoggedInRoute
                        path="/rate/:id?/:name?"
                        component={RatesPage}
                    />
                    <LoggedInRoute
                        path="/fx/:id?/:name?"
                        component={CurrencyPage}
                    />
                    <LoggedInRoute
                        path="/CreditStrategy/:id?/:name?"
                        component={CreditStrategyPage}
                    />
                    <LoggedInRoute path="/sso/:data?" component={SsoLogin} />
                    <LoggedInRoute
                        path="/network/:id?"
                        component={NetworkGraph}
                    />
                    <LoggedInRoute path="/watchlist" component={Watchlist} />
                    <LoggedInRoute path="/analysts" component={AnalystsPage} />
                    <LoggedInRoute
                        path="/corporateaccess"
                        component={CorporateAccess}
                    />
                    <LoggedInRoute path="/disclaimer" component={Disclaimer} />
                    <LoggedInRoute
                        path="/industry/:id?/:name?"
                        component={IndustryPage}
                    />
                    <LoggedInRoute
                        path="/country/:id?/:name?"
                        component={CountryPage}
                    />
                    <LoggedInRoute path="/etf" component={ETF} />
                    <LoggedInRoute exact path="/learn" component={LearnPage} />

                    <Route
                        render={(props) => (
                            <Result
                                status="404"
                                title="404"
                                subTitle={
                                    props.location.pathname === '/register'
                                        ? `You are already registered and logged into Insights Direct - click on "Back to Home" to continue`
                                        : 'Sorry, the page you visited does not exist.'
                                }
                                extra={
                                    <Button type="primary" href="/">
                                        Back Home
                                    </Button>
                                }
                            />
                        )}
                    />
                </Switch>
            </Suspense>
        </Router>
    );
};

export default AppRouter;
